import { render, staticRenderFns } from "./landing-layout.vue?vue&type=template&id=46778af6&scoped=true&"
import script from "./landing-layout.vue?vue&type=script&lang=js&"
export * from "./landing-layout.vue?vue&type=script&lang=js&"
import style0 from "./landing-layout.vue?vue&type=style&index=0&id=46778af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46778af6",
  null
  
)

export default component.exports